// #region imports

// --- Angular
import {
  Component,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

// #endregion

@Component({
  selector: 'hs-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyComponent {
  @Input() isAdding: boolean | null = null;
  @Input() errorMessage: string | null = null;
  @Input() validationMessageSurveyNameRequired: string | null = null;
  @Input() validationMessageSurveyNameMaxLength: string | null = null;
  @Input() validationMessageIsbnNumberRequired: string | null = null;
  @Input() validationMessageIsbnNumberMaxLength: string | null = null;
}
